var Cookie = {
  parse (cookieStr) {
    var cookies = {};
    (cookieStr || '').split(';').forEach((p) => {
      let itm = p.trim().split('=')
      cookies[itm[0]] = itm[1]
    })
    return cookies
  },
  append (origin, newCookies) {
    var cookies = this.parse(origin)
    for (var k in newCookies) {
      cookies[k] = newCookies[k]
    }
    return this.format(cookies)
  },
  format (cookies) {
    var items = []
    for (var k in cookies) {
      items.push(`${k}=${cookies[k]}`)
    }
    return items.join(';')
  },
  set (name, value, expHour, domain, path) {
    if (process.browser) {
      let cookie = name + '=' + encodeURIComponent(value || '') + (expHour ? '; expires=' + new Date(new Date().getTime() + (expHour - 0) * 3600000).toUTCString() : '') + '; domain=' + (domain || document.domain) + '; path=' + (path || '/')
      document.cookie = cookie
    }
  },
  get (name) {
    if (process.browser) {
      return document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)')) == null ? null : decodeURIComponent(RegExp.$2)
    }
  },
  remove (name, domain, path) {
    if (this.get(name) != null) {
      this.set(name, null, -1, domain, path)
    }
  }
}

export default Cookie



// WEBPACK FOOTER //
// ./src/mods/cookie.js